import _asyncToGenerator from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { getLyric } from "@/servers/allListDetail/listDetailAPI";
import { onMounted, reactive, watch, computed } from "vue";
import { useStore } from "vuex";
import RotateCover from "@/baseui/player/rotateCover.vue";
import SongLyric from "@/baseui/player/songLyric.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    expose();
    var store = useStore();
    /** 是否展示歌曲详情 */

    var isShowSongDetail = computed(function () {
      return store.state.player.isShowSongDetail;
    });
    /** 当前歌曲 */

    var currentSong = computed(function () {
      return store.state.player.currentSong;
    });
    var lyricState = reactive({
      lyric: "",
      lyricUser: undefined,
      transLyric: undefined,
      transLyricUser: undefined
    });
    /** 获取歌曲歌词 */

    var getSongLyric = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var _yield$getLyric, lrc, lyricUser, tlyric, transUser;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getLyric(id);

              case 2:
                _yield$getLyric = _context.sent;
                lrc = _yield$getLyric.lrc;
                lyricUser = _yield$getLyric.lyricUser;
                tlyric = _yield$getLyric.tlyric;
                transUser = _yield$getLyric.transUser;
                lyricState.lyric = lrc.lyric;
                lyricState.transLyric = tlyric === null || tlyric === void 0 ? void 0 : tlyric.lyric;
                lyricState.lyricUser = lyricUser;
                lyricState.transLyricUser = transUser;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getSongLyric(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    watch(function () {
      return store.state.player.currentSong;
    }, function (song) {
      if (song && song.id) {
        getSongLyric(Number(song.id));
      }
    });
    watch(function () {
      return isShowSongDetail;
    }, function (nv, ov) {
      console.log("isShowSongDetail", nv.value, ov.value);
    });
    onMounted(function () {
      var _currentSong$value;

      var id = (_currentSong$value = currentSong.value) === null || _currentSong$value === void 0 ? void 0 : _currentSong$value.id;

      if (id) {
        getSongLyric(Number(id));
      }
    });
    var __returned__ = {
      store: store,
      isShowSongDetail: isShowSongDetail,
      currentSong: currentSong,
      lyricState: lyricState,
      getSongLyric: getSongLyric,
      RotateCover: RotateCover,
      SongLyric: SongLyric
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});